/** @class
 * @classdesc Vector2
 * @constructor
 *
 *[EN] @property {number} x - x value
 *[EN] @property {number} y - y value
 *[EN] @param {number} x - x value
 *[EN] @param {number} y - y value
 *
 *[JP] @param {number} x - xの値
 *[JP] @param {number} y - yの値
 *[JP] @property {number} x - xの値
 *[JP] @property {number} y - yの値
 */
function Vector2(x, y) {
	this.x = x;
	this.y = y;
}
module.exports = Vector2;

//▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄
/** 
 *[EN] Get the distance to another point
 *[EN] @param {Vector2} the other point to get the distance from
 *[EN] @return {number} distance
 * 
 *[JP] 他の点との距離を求める
 *[JP] @param {Vector2} 距離を求める対象の点
 *[JP] @return {number} 距離
 */
Vector2.prototype.distance = function (vec2) {
	var dx = vec2.x - this.x;
	var dy = vec2.y - this.y;
	return Math.sqrt(dx * dx + dy * dy);
};

//▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄
/** 
 *[EN] Get the squared distance to another point
 *[EN] @param {Vector2} the other point to get the distance from
 *[EN] @return {number} squared distance
 * 
 *[JP] 他の点との距離の二乗を求める
 *[JP] @param {Vector2} 距離を求める対象の点
 *[JP] @return {number} 距離の二乗
 */
Vector2.prototype.distanceSquared = function (vec2) {
	var dx = vec2.x - this.x;
	var dy = vec2.y - this.y;
	return dx * dx + dy * dy;
};

//▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄
/** 
 *[EN] Set vector values
 *[EN] @param {number} x - 
 *[EN] @param {number} y - 
 *[EN] @return {Vector2} the vector instance itself
 * 
 *[JP] ベクトルの値を設定
 *[JP] @param {number} x - xの値
 *[JP] @param {number} y - yの値
 *[JP] @return {Vector2} ベクトルのインスタンス自身
 */
Vector2.prototype.set = function (x, y) {
	this.x = x;
	this.y = y;
	return this;
};

//▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄
/** 
 *[EN] Set vector values from an array of numbers
 *[EN] @param {number[]} arr - array of number to transform to a vector
 *[EN] @return {Vector2} the vector instance itself
 * 
 *[JP] 数字の配列を使ってベクトルの値を設定する
 *[JP] @param {number[]} arr - ベクトルに変換したい数字の配列
 *[JP] @return {Vector2} ベクトルのインスタンス自身
 */
Vector2.prototype.setArray = function (arr) {
	this.x = arr[0];
	this.y = arr[1];
	return this;
};

//▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄
/** 
 *[EN] Set vector values from another vector
 *[EN] @param {Vector2} vec2 - vector to be copied
 *[EN] @return {Vector2} the vector instance itself
 * 
 *[JP] 他のベクトルを元にベクトルの値を設定する
 *[JP] @param {Vector2} vec2 - コピーすべきベクトル
 *[JP] @return {Vector2} ベクトルのインスタンス自身
 */
Vector2.prototype.setVector2 = function (vec2) {
	this.x = vec2.x;
	this.y = vec2.y;
	return this;
};

// Operations modifying the vector

//▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄
/** 
 *[EN] Add a scalar value to the vector
 *[EN] @param {number} s - scalar value to be added
 *[EN] @return {Vector2} the vector itself after modification
 * 
 *[JP] ベクトルにスカラー値を加算する
 *[JP] @param {number} s - 加算するスカラー値
 *[JP] @return {Vector2} 加算後のベクトル
 */
Vector2.prototype.addScalar = function (s) {
	this.x += s;
	this.y += s;
	return this;
};

//▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄
/** 
 *[EN] Substract a scalar value to the vector
 *[EN] @param {number} s - scalar value to be substracted
 *[EN] @return {Vector2} the vector itself after modification
 * 
 *[JP] ベクトルからスカラー値を減算する
 *[JP] @param {number} s - 減算するスカラー値
 *[JP] @return {Vector2} 減算後のベクトル
 */
Vector2.prototype.subtractScalar = function (s) {
	this.x -= s;
	this.y -= s;
	return this;
};

//▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄
/** 
 *[EN] Multiply a scalar value to the vector
 *[EN] @param {number} s - scalar value to be multiplied
 *[EN] @return {Vector2} the vector itself after modification
 * 
 *[JP] ベクトルに対してスカラー値を乗算する
 *[JP] @param {number} s - 乗算するスカラー値
 *[JP] @return {Vector2} 乗算後のベクトル
 */
Vector2.prototype.multiplyScalar = function (s) {
	this.x *= s;
	this.y *= s;
	return this;
};

//▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄
/** 
 *[EN] Divide the vector by a scalar value
 *[EN] @param {number} s - scalar value used for division
 *[EN] @return {Vector2} the vector itself after modification
 * 
 *[JP] ベクトルをスカラー値で除算する
 *[JP] @param {number} s - 除算するスカラー値
 *[JP] @return {Vector2} 除算後のベクトル
 */
Vector2.prototype.divideScalar = function (s) {
	this.x /= s;
	this.y /= s;
	return this;
};

//▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄
/** 
 *[EN] Vector addition
 *[EN] @param {Vector2} vec2 - vector to add
 *[EN] @return {Vector2} the vector itself after modification
 * 
 *[JP] ベクトルの加算
 *[JP] @param {Vector2} vec2 - 加算するベクトル
 *[JP] @return {Vector2} 加算後のベクトル
 */
Vector2.prototype.add = function (vec2) {
	this.x += vec2.x;
	this.y += vec2.y;
	return this;
};

//▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄
/** 
 *[EN] Vector substraction
 *[EN] @param {Vector2} vec2 - vector to substract
 *[EN] @return {Vector2} the vector itself after modification
 * 
 *[JP] ベクトルの減算
 *[JP] @param {Vector2} vec2 - 減算するベクトル
 *[JP] @return {Vector2} 減算後のベクトル
 */
Vector2.prototype.subtract = function (vec2) {
	this.x -= vec2.x;
	this.y -= vec2.y;
	return this;
};

//▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄
/** 
 *[EN] Vector multiplication
 *[EN] @param {Vector2} vec2 - vector to multiply
 *[EN] @return {Vector2} the vector itself after modification
 * 
 *[JP] ベクトルの乗算
 *[JP] @param {Vector2} vec2 - 乗算するベクトル
 *[JP] @return {Vector2} 乗算後のベクトル
 */
Vector2.prototype.multiply = function (vec2) {
	this.x *= vec2.x;
	this.y *= vec2.y;
	return this;
};

//▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄
/** 
 *[EN] Vector division
 *[EN] @param {Vector2} vec2 - vector used for division
 *[EN] @return {Vector2} the vector itself after modification
 * 
 *[JP] ベクトルの除算
 *[JP] @param {Vector2} vec2 - 除算するベクトル
 *[JP] @return {Vector2} 除算後のベクトル
 */
Vector2.prototype.divide = function (vec2) {
	this.x /= vec2.x;
	this.y /= vec2.y;
	return this;
};

//▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄
/** 
 *[EN] Vector normalization. Makes this vector have a magnitude of 1.
 *[EN] When normalized, a vector keeps the same direction but its length is 1
 *[EN] If this vector is too small to be normalized it will be set to zero
 *
 *[EN] @param {Vector2} vec2 - vector used for division
 *[EN] @return {Vector2} the vector itself after normalization
 * 
 *[JP] ベクトルの正規化。正規化を行うとベクトルの大きさが1になります。
 *[JP] ベクトルの方向は変わりませんが長さが1になります。
 *[JP] もし、正規化するベクトルが小さすぎる場合はゼロに設定されます。
 *
 *[JP] @param {Vector2} vec2 - 除算に使うベクトル
 *[JP] @return {Vector2} 正規化後のベクトル
 */
Vector2.prototype.normalize = function () {
	var length = Math.sqrt(this.x * this.x + this.y * this.y);
	if (length === 0) { length = 1; }

	var l = 1 / length;
	this.x *= l;
	this.y *= l;
	return this;
};

//▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄
Vector2.prototype.negate = function () {
	this.x = -this.x;
	this.y = -this.y;
	return this;
};

//▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄
Vector2.prototype.translate = Vector2.prototype.add;
Vector2.prototype.scale = Vector2.prototype.multiply;
Vector2.prototype.rotate = function (rotation) {
	if (rotation === 0) {
		return this;
	}

	var cos = Math.cos(rotation);
	var sin = Math.sin(rotation);

	var x = this.x;
	var y = this.y;

	this.x = x * cos + y * sin;
	this.y = y * cos - x * sin;
	return this;
};

Vector2.prototype.skew = function (skew) {
	var skewX = skew.x;
	var skewY = skew.y;
	if (skewX === 0 && skewY === 0) {
		return this;
	}

	var x = this.x;
	var y = this.y;

	this.x = x + y * Math.tan(skewX);
	this.y = y + x * Math.tan(skewY);
	return this;
};

//▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄
Vector2.prototype.multiplyMatrix3x3 = function (mat3) {
	var m = mat3._matrix;
	var x = this.x;
	var y = this.y;

	this.x = x * m[0] + y * m[3];
	this.y = x * m[1] + y * m[4];
	return this;
};

//▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄
Vector2.prototype.untranslate = Vector2.prototype.subtract;
Vector2.prototype.unscale = Vector2.prototype.divide;
Vector2.prototype.unrotate = function (rotation) { return this.rotate(-rotation); };
Vector2.prototype.unskew = function (skew) {
	var skewX = skew.x;
	var skewY = skew.y;
	if (skewX === 0 && skewY === 0) {
		return this;
	}

	var x = this.x;
	var y = this.y;

	this.x = x - y * Math.tan(skewX);
	this.y = y - x * Math.tan(skewY);
	return this;
};

// Operations creating a new vector

//▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄
/** 
 *[EN] Vector scalar addition 
 *[EN] This operation doesn't modify the vector and create a new one.
 *[EN] @param {number} s - scalar value to be added
 *[EN] @return {Vector2} transformed vector
 * 
 *[JP] ベクトルに対するスカラー値の加算
 *[JP] このメソッドは新たなベクトルを生成して返却します。元のベクトルへの変更はありません。
 *[JP] @param {number} s - 加算するスカラー値
 *[JP] @return {Vector2} 加算後のベクトル
 */
Vector2.prototype.additionScalar = function (s) {
	return new Vector2(this.x + s, this.y + s);
};

//▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄
/** 
 *[EN] Vector scalar substraction 
 *[EN] This operation doesn't modify the vector and create a new one.
 *[EN] @param {number} s - scalar value to be substracted
 *[EN] @return {Vector2} transformed vector
 * 
 *[JP] ベクトルに対するスカラー値の減算
 *[JP] このメソッドは新たなベクトルを生成して返却します。元のベクトルへの変更はありません。
 *[JP] @param {number} s - 減算するスカラー値
 *[JP] @return {Vector2} 減算後のベクトル
 */
Vector2.prototype.subtractionScalar = function (s) {
	return new Vector2(this.x - s, this.y - s);
};

//▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄
/** 
 *[EN] Vector scalar multiplication 
 *[EN] This operation doesn't modify the vector and create a new one.
 *[EN] @param {number} s - scalar value to be multiplied
 *[EN] @return {Vector2} transformed vector
 * 
 *[JP] ベクトルに対するスカラー値の乗算
 *[JP] このメソッドは新たなベクトルを生成して返却します。元のベクトルへの変更はありません。
 *[JP] @param {number} s - 乗算するスカラー値
 *[JP] @return {Vector2} 乗算後のベクトル
 */
Vector2.prototype.multiplicationScalar = function (s) {
	return new Vector2(this.x * s, this.y * s);
};

//▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄
/** 
 *[EN] Vector scalar division 
 *[EN] This operation doesn't modify the vector and create a new one.
 *[EN] @param {number} s - scalar value to be divided
 *[EN] @return {Vector2} transformed vector
 * 
 *[JP] ベクトルに対するスカラー値の除算
 *[JP] このメソッドは新たなベクトルを生成して返却します。元のベクトルへの変更はありません。
 *[JP] @param {number} s - 除算するスカラー値
 *[JP] @return {Vector2} 除算後のベクトル
 */
Vector2.prototype.divisionScalar = function (s) {
	return new Vector2(this.x / s, this.y / s);
};

//▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄
/** 
 *[EN] Vector addition 
 *[EN] This operation doesn't modify the vector and create a new one.
 *[EN] @param {Vector2} vec2 - vector to be added
 *[EN] @return {Vector2} transformed vector
 * 
 *[JP] ベクトルに対し他のベクトルを加算する
 *[JP] このメソッドは新たなベクトルを生成して返却します。元のベクトルへの変更はありません。
 *[JP] @param {Vector2} vec2 - 加算するベクトル
 *[JP] @return {Vector2} 加算後のベクトルr
 */
Vector2.prototype.addition = function (vec2) {
	return new Vector2(this.x + vec2.x, this.y + vec2.y);
};

//▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄
/** 
 *[EN] Vector substraction 
 *[EN] This operation doesn't modify the vector and create a new one.
 *[EN] @param {Vector2} vec2 - vector to be substracted
 *[EN] @return {Vector2} transformed vector
 * 
 *[JP] ベクトルから他のベクトルを減算する
 *[JP] このメソッドは新たなベクトルを生成して返却します。元のベクトルへの変更はありません。
 *[JP] @param {Vector2} vec2 - 減算するベクトル
 *[JP] @return {Vector2} 減算後のベクトル
 */
Vector2.prototype.subtraction = function (vec2) {
	return new Vector2(this.x - vec2.x, this.y - vec2.y);
};

//▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄
/** 
 *[EN] Vector multiplication 
 *[EN] This operation doesn't modify the vector and create a new one.
 *[EN] @param {Vector2} vec2 - vector to be multiplied
 *[EN] @return {Vector2} transformed vector
 * 
 *[JP] ベクトルと他のベクトルを掛け合わせる
 *[JP] このメソッドは新たなベクトルを生成して返却します。元のベクトルへの変更はありません。
 *[JP] @param {Vector2} vec2 - 掛け合わせるベクトル
 *[JP] @return {Vector2} 掛けあわせた後のベクトル
 */
Vector2.prototype.multiplication = function (vec2) {
	return new Vector2(this.x * vec2.x, this.y * vec2.y);
};

//▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄
/** 
 *[EN] Vector division 
 *[EN] This operation doesn't modify the vector and create a new one.
 *[EN] @param {Vector2} vec2 - vector to be divided
 *[EN] @return {Vector2} transformed vector
 * 
 *[JP] ベクトルを他のベクトルで割る
 *[JP] このメソッドは新たなベクトルを生成して返却します。元のベクトルへの変更はありません。
 *[JP] @param {Vector2} vec2 - 除数のベクトル
 *[JP] @return {Vector2} 除算後のベクトル
 */
Vector2.prototype.division = function (vec2) {
	return new Vector2(this.x / vec2.x, this.y / vec2.y);
};


//▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄
Vector2.prototype.negation = function () {
	return new Vector2(-this.x, -this.y);
};

//▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄
Vector2.prototype.translation = Vector2.prototype.addition;
Vector2.prototype.scaling = Vector2.prototype.multiplication;
Vector2.prototype.rotation = function (rotation) { return this.copy().rotate(rotation); };
Vector2.prototype.skewing = function (skew) { return this.copy().skew(skew); };


//▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄
Vector2.prototype.untranslation = Vector2.prototype.subtraction;
Vector2.prototype.unscaling = Vector2.prototype.division;
Vector2.prototype.unrotation = function (rotation) { return this.copy().rotate(-rotation); };
Vector2.prototype.unskewing = function (skew) { return this.copy().unskew(skew); };

//▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄
Vector2.prototype.multiplicationMatrix3x3 = function (mat3) {
	var m = mat3._matrix;
	var x = this.x * m[0] + this.y * m[3];
	var y = this.x * m[1] + this.y * m[4];
	return new Vector2(x, y);
};

//▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄
/** 
 *[EN] Vector normalization
 *[EN] @return {Vector2}
 * 
 *[JP] ベクトルの正規化
 *[JP] @return {Vector2}
 */
Vector2.prototype.normal = function () {
	var length = Math.sqrt(this.x * this.x + this.y * this.y);
	if (length === 0) { length = 1; }
	return new Vector2(this.x / length, this.y / length);
};

//▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄
/** 
 *[EN] Create a copy of the vector
 *[EN] @return {Vector2} vector copy
 * 
 *[JP] ベクトルのコピーを作成する
 *[JP] @return {Vector2} ベクトルのコピー
 */
Vector2.prototype.copy = function () {
	return new Vector2(this.x, this.y);
};

//▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄
/** 
 *[EN] Returns the length of this vector
 *[EN] The length of the vector is square root of (x*x+y*y)
 *[EN] @return {number} vector length
 * 
 *[JP] ベクトルの長さを求める
 *[JP] ベクトルの長さは (x*x+y*y)の平方根
 *[JP] @return {number} ベクトルの長さ
 */
Vector2.prototype.length = function () {
	return Math.sqrt(this.x * this.x + this.y * this.y);
};

//▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄
/** 
 *[EN] Dot Product.
 *
 *[EN] For normalized vectors Dot returns 1 if they point in exactly the same direction;
 *[EN] -1 if they point in completely opposite directions; 
 *[EN] and a number in between for other cases (e.g. Dot returns zero if vectors are perpendicular).
 *[EN] For vectors of arbitrary length the Dot return values are similar: 
 *[EN] they get larger when the angle between vectors decreases.
 *
 *[EN] @param {Vector2} the other vector to de the dot product
 *[EN] @return {number} dot product
 * 
 *[JP] 内積
 *
 *[JP] 正規化され、かつ、同じ方向を向いているベクトルの場合内積は1となる
 *[JP] 逆方向を向いている場合、内積は-1となる。その他の場合は1と-1の間の数値となる（例：垂直な場合の内積はゼロ）
 *[JP] 正規化されてないベクトルの場合も同様に、ベクトル間の角度が増えるにつれ値が大きくなる。
 *
 *[JP] @param {Vector2} 内積を求める他のベクトル
 *[JP] @return {number} 内積
 */
Vector2.prototype.dot = function (vec2) {
	return this.x * vec2.x + this.y * vec2.y;
};

//▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄
/** 
 *[EN] Returns a nicely formatted string for this vector.
 *[JP] ベクトルを綺麗に整形した文字列を求める
 * @return {string} 
 */
Vector2.prototype.toString = function () {
	return '[' + this.x + ', ' + this.y + ']';
};

// Static method

//▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄
/** 
 *[EN] Linear interpolation between two vectors
 *[EN] When t = 0 returns the first vector. When t = 1 returns the second vector.
 *[EN] When t = 0.5 returns the vector midway between first and second vector.
 *[JP] 2つのベクトルの間の線形補間を求める
 *[JP] t=0の場合は1つ目のベクトルを返す。t=1の場合は2つ目のベクトルを返す。
 *[JP] t=0.5の場合は2つのベクトルの中間にあるベクトルを返す。
 * @static
 *
 *[EN] @param {number} t - interpolant
 *[EN] @param {Vector2} vec2a - first vector
 *[EN] @param {Vector2} vec2b - second vector
 *[EN] @return {Vector2} interpolated vector
 * 
 *[JP] @param {number} t - 補間式
 *[JP] @param {Vector2} vec2a - 1つ目のベクトル
 *[JP] @param {Vector2} vec2b - 2つ目のベクトル
 *[JP] @return {Vector2} 補間されたベクトル
 */
Vector2.lerp = function (t, vec2a, vec2b) {
	return new Vector2(
		vec2a.x * (1 - t) + vec2b.x * t,
		vec2a.y * (1 - t) + vec2b.y * t
	);
};
